import { formatRupiah } from "@/components/property/roomMeta";

export { formatRupiah };

export const DISCOUNT_TYPE_LABELS = {
  percentage: "Persentase (%)",
  fixed_amount: "Nominal Tetap (Rp)",
};

export const PROMO_STATUS_LABELS = {
  active: "Aktif",
  inactive: "Nonaktif",
};

export const PROMO_STATUS_STYLES = {
  active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  inactive: "bg-muted text-muted-foreground border-border",
};

export function discountLabel(promo) {
  if (!promo) return "-";
  if (promo.discount_type === "percentage") return `${promo.discount_value}%`;
  return formatRupiah(promo.discount_value);
}

export function formatPromoDate(iso) {
  if (!iso) return "-";
  const s = iso.length === 10 ? iso + "T00:00:00" : iso;
  const d = new Date(s);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
